import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { NibrasDialogModule } from '@nibras/common-components/nibras-dialog';
import { GenericDialogComponent } from './generic-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    NibrasDialogModule
  ],
  declarations: [GenericDialogComponent],
  exports: [GenericDialogComponent]
})
export class GenericDialogModule {}
